import script from "./SetMprSaleValue.vue?vue&type=script&setup=true&lang=js"
export * from "./SetMprSaleValue.vue?vue&type=script&setup=true&lang=js"

import "./SetMprSaleValue.vue?vue&type=style&index=0&id=12a08d7e&lang=css"

const __exports__ = script;

export default __exports__